import { z } from "zod";

/** 실측: 서버는 roles[] 를 보낸다. permissions[] 는 아직 없다 (OD-024). */
export const currentUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  displayName: z.string(),
  /**
   * 실측: `handle` 은 `displayName#handleSuffix` 로 만들어진다 —
   * 닉네임을 바꾸면 같이 바뀐다. 식별자로 쓰지 않는다. 안정적인 건 id 와 handleSuffix.
   */
  handle: z.string(),
  /*
   * 서버는 null 을 보낼 수 있습니다. 칼럼이 nullable 이고, `public_handle` 이
   * 없을 때를 대비해 displayName 만 돌려주도록 이미 짜여 있습니다.
   * 여기서 string 만 받으면 정상 200 응답이 스키마에서 떨어지고, 그 결과
   * 로그인한 사용자가 조용히 게스트가 됩니다 — 화면에는 "로그인해 주세요"만
   * 뜨고 아무리 다시 로그인해도 낫지 않습니다. 실제로 그렇게 막혔습니다.
   */
  handleSuffix: z.string().nullable(),
  role: z.string(),
  roles: z.array(z.string()).optional(),
  permissions: z.array(z.string()).optional(),
});
export const authResultSchema = z.object({ token: z.string(), user: currentUserSchema });
export const favoriteSchema = z.object({ targetType: z.string(), targetId: z.string() });
export type CurrentUserDto = z.infer<typeof currentUserSchema>;
